import { render } from "./NoneLayout.vue?vue&type=template&id=10cc7a30"
const script = {}

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__